module.exports = __webpack_public_path__ + "static/VeneerCleanRound-d2cca7fc5f34482a719c5f876252c8d9.woff2";